<template>


    <div class="md:rounded h-full border-gray-100 dark:bg-gray-900/70 bg-white border dark:border-gray-800">
        <header class="border-gray-100 flex items-stretch border-b dark:border-gray-800">
            <p
                class="flex items-center py-3 flex-grow font-bold px-6">
                <span class="icon"><i class="mdi mdi-finance"></i></span>
                {{ graphTitle }}
            </p>
            <div class="buttons right nowrap mr-1" v-if="graphValues.labels.length > 0">
                <div class="inline-flex rounded-md shadow-sm" role="group">
                    <button type="button" @click="changeDisplay('graph')"
                            :class="displayGraph ? 'bg-blue-500 text-white dark:!bg-gray-900' : 'text-gray-900 bg-white'"
                            class="inline-flex items-center py-2 px-4 focus:outline-none font-medium rounded-l-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                        <span class="icon"><i class="mdi mdi-chart-areaspline"></i></span>
                        <!--                    Graph-->
                    </button>
                    <button type="button" @click="changeDisplay('list')"
                            :class="!displayGraph ? 'bg-blue-500 text-white dark:!bg-gray-900' : 'text-gray-900 bg-white'"
                            class="inline-flex items-center py-2 px-4 focus:outline-none font-medium border border-t border-gray-200 hover:bg-gray-100 hover:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                        <span class="icon"><i class="mdi mdi-format-list-bulleted"></i></span>
                        <!--                    List-->
                    </button>
                    <button type="button" @click="toPDF"
                            class="inline-flex items-center py-2 px-4 focus:outline-none font-medium rounded-r-md border border-gray-200 hover:bg-gray-100 hover:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                        <span class="icon"><i class="mdi mdi-file-pdf-box"></i></span>
                        <!--                    List-->
                    </button>
                </div>
            </div>
        </header>
        <div class="card-content" :class="{'content-center':displayGraph}">
            <div class="chart-area" :class="{'w-full':graphValues.labels.length > 0}">
                <div class="h-full">
                    <div :id="slugify(graphTitle)">
                        <template v-if="loadingData">
                            <div v-if="graphValues.labels.length > 0">
                                <template v-if="displayGraph">
                                    <vue3-chart-js
                                        ref="chartRef"
                                        :id="graphType"
                                        :type="graphType"
                                        :data="graphValues"
                                        :options="graphOptions"
                                    ></vue3-chart-js>
                                </template>
                                <template v-else>
                                    <table>
                                        <tr>
                                            <th>Label</th>
                                            <th>Value</th>
                                        </tr>
                                        <tbody>
                                        <template v-for="(value,index) in graphValues.labels">
                                            <tr>
                                                <td>{{ value }}</td>
                                                <td>{{ graphValues.datasets[0].data[index] }}</td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </template>
                            </div>
                            <div v-else>
                                <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"
                                     viewBox="0 0 647.63626 632.17383" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <path
                                        d="M687.3279,276.08691H512.81813a15.01828,15.01828,0,0,0-15,15v387.85l-2,.61005-42.81006,13.11a8.00676,8.00676,0,0,1-9.98974-5.31L315.678,271.39691a8.00313,8.00313,0,0,1,5.31006-9.99l65.97022-20.2,191.25-58.54,65.96972-20.2a7.98927,7.98927,0,0,1,9.99024,5.3l32.5498,106.32Z"
                                        transform="translate(-276.18187 -133.91309)" fill="#f2f2f2"/>
                                    <path
                                        d="M725.408,274.08691l-39.23-128.14a16.99368,16.99368,0,0,0-21.23-11.28l-92.75,28.39L380.95827,221.60693l-92.75,28.4a17.0152,17.0152,0,0,0-11.28028,21.23l134.08008,437.93a17.02661,17.02661,0,0,0,16.26026,12.03,16.78926,16.78926,0,0,0,4.96972-.75l63.58008-19.46,2-.62v-2.09l-2,.61-64.16992,19.65a15.01489,15.01489,0,0,1-18.73-9.95l-134.06983-437.94a14.97935,14.97935,0,0,1,9.94971-18.73l92.75-28.4,191.24024-58.54,92.75-28.4a15.15551,15.15551,0,0,1,4.40966-.66,15.01461,15.01461,0,0,1,14.32032,10.61l39.0498,127.56.62012,2h2.08008Z"
                                        transform="translate(-276.18187 -133.91309)" fill="#3f3d56"/>
                                    <path
                                        d="M398.86279,261.73389a9.0157,9.0157,0,0,1-8.61133-6.3667l-12.88037-42.07178a8.99884,8.99884,0,0,1,5.9712-11.24023l175.939-53.86377a9.00867,9.00867,0,0,1,11.24072,5.9707l12.88037,42.07227a9.01029,9.01029,0,0,1-5.9707,11.24072L401.49219,261.33887A8.976,8.976,0,0,1,398.86279,261.73389Z"
                                        transform="translate(-276.18187 -133.91309)" fill="#ff6347"/>
                                    <circle cx="190.15351" cy="24.95465" r="20" fill="#ff6347"/>
                                    <circle cx="190.15351" cy="24.95465" r="12.66462" fill="#fff"/>
                                    <path
                                        d="M878.81836,716.08691h-338a8.50981,8.50981,0,0,1-8.5-8.5v-405a8.50951,8.50951,0,0,1,8.5-8.5h338a8.50982,8.50982,0,0,1,8.5,8.5v405A8.51013,8.51013,0,0,1,878.81836,716.08691Z"
                                        transform="translate(-276.18187 -133.91309)" fill="#e6e6e6"/>
                                    <path
                                        d="M723.31813,274.08691h-210.5a17.02411,17.02411,0,0,0-17,17v407.8l2-.61v-407.19a15.01828,15.01828,0,0,1,15-15H723.93825Zm183.5,0h-394a17.02411,17.02411,0,0,0-17,17v458a17.0241,17.0241,0,0,0,17,17h394a17.0241,17.0241,0,0,0,17-17v-458A17.02411,17.02411,0,0,0,906.81813,274.08691Zm15,475a15.01828,15.01828,0,0,1-15,15h-394a15.01828,15.01828,0,0,1-15-15v-458a15.01828,15.01828,0,0,1,15-15h394a15.01828,15.01828,0,0,1,15,15Z"
                                        transform="translate(-276.18187 -133.91309)" fill="#3f3d56"/>
                                    <path
                                        d="M801.81836,318.08691h-184a9.01015,9.01015,0,0,1-9-9v-44a9.01016,9.01016,0,0,1,9-9h184a9.01016,9.01016,0,0,1,9,9v44A9.01015,9.01015,0,0,1,801.81836,318.08691Z"
                                        transform="translate(-276.18187 -133.91309)" fill="#ff6347"/>
                                    <circle cx="433.63626" cy="105.17383" r="20" fill="#ff6347"/>
                                    <circle cx="433.63626" cy="105.17383" r="12.18187" fill="#fff"/>
                                </svg>
                                <p>
                                    No data available!
                                </p>
                            </div>
                        </template>
                        <template v-else>
                            <div class="loader"></div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue3ChartJs from '@j-t-mcc/vue3-chartjs';
import {usePage} from "@inertiajs/inertia-vue3";
import html2pdf from "html2pdf.js";
import {ref} from 'vue';

export default {
    name: "WidgetLayout",
    components: {
        Vue3ChartJs
    },
    setup(props) {
        const chartRef = ref(null);
        let displayGraph = ref(true);
        const pdfOptions = {
            margin: 15,
            image: {
                type: 'jpeg',
                quality: 1,
            },
            html2canvas: {scale: 3},
            jsPDF: {
                unit: 'mm',
                format: 'a4',
                orientation: 'p'
            },
            filename: `${slugify(props.graphTitle)}-${displayGraph ? 'graph' : 'list'}.pdf`
        }

        function slugify(value) {
            return value.normalize('NFD') // split an accented letter in the base letter and the acent
                .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
                .toLowerCase()
                .trim()
                .replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
                .replace(/\s+/g, '-') // separator
        }

        function toPDF() {
            let contentHtml;
            pdfOptions.filename = `referex-${slugify(props.graphTitle)}-${displayGraph.value ? 'graph' : 'list'}.pdf`;
            if (displayGraph.value)
                contentHtml = `<div class="w-full my-4"><img src="${chartRef.value.chartJSState.chart.toBase64Image()}"></div>`;
            else
                contentHtml = (document.getElementById(slugify(props.graphTitle))).innerHTML;

            let html = `<div style="height:100vh">
<h3 class="text-3xl text-gray-800 font-bold leading-none mb-12">${props.graphTitle}</h3>
${contentHtml}
<div class="absolute left-0 right-0 bottom-1">Referex App &bull; ${usePage().props.value.user.name}  &bull; ${new Date()}</div>
</div>`;
            const placeholder = document.createElement('div');
            placeholder.className = "h-full";
            placeholder.innerHTML = html;
            let el = placeholder.firstElementChild;
            html2pdf().from(el).set(pdfOptions).save();
        }

        function changeDisplay(value) {
            displayGraph.value = (value === 'graph');
        }

        return {
            chartRef,
            pdfOptions,
            slugify,
            toPDF,
            displayGraph,
            changeDisplay
        }
    }

    ,
    props: {
        loadingData: Boolean,
        graphType: String,
        graphValues: Object,
        graphOptions: Object,
        graphTitle: String,
    }
}
</script>

<style scoped>
.content-center {
    height: 100%;
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -25px;
}

.loader {
    border: 12px solid #f3f3f3; /* Light grey */
    border-top: 12px solid #ff6347; /* Orange */
    border-radius: 50%;
    width: 100px;
    height: 100px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@media (max-width: 640px) {
    .content-center {
        height: 80%;
    }
}
</style>
